import { render, staticRenderFns } from "./EditSupplementsDialog.vue?vue&type=template&id=3842cc68&scoped=true"
import script from "./EditSupplementsDialog.vue?vue&type=script&lang=js"
export * from "./EditSupplementsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditSupplementsDialog.vue?vue&type=style&index=0&id=3842cc68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842cc68",
  null
  
)

export default component.exports